<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12 bg-white shadow-sm rounded-lg border mb-5">
                <div class="m-3">
                    <div class="form-group row">
                        <div id="map" style="width: 100%; height: 800px" class="mh-75"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import MapBox from '../mixins/MapBox/Map';

export default {
    mixins: [
        MapBox,
    ],
    props: {
        trans: {
            type: Object,
            required: true
        },
        positions: {
            type: Array,
            default: function () {
                return [];
            }
        },
    },
    methods: {
        applyHeatMap() {
            this.mySmartMap.addSource('earthquakes', {
                'type': 'geojson',
                'data': {
                    type: 'FeatureCollection',
                    crs: {
                        "type": "name",
                        "properties": {
                            "name": "urn:ogc:def:crs:OGC:1.3:CRS84"
                        }
                    },
                    features: this.positions.map(position => ({
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: [position.lng, position.lat]
                        },
                        properties: {}
                    }))
                }
            });

            this.mySmartMap.addLayer(
                {
                    'id': 'earthquakes-heat',
                    'type': 'heatmap',
                    'source': 'earthquakes',
                    'maxzoom': 23,
                    'paint': {
                        // Increase the heatmap weight based on frequency and property magnitude
                        'heatmap-weight': [
                            'interpolate',
                            ['linear'],
                            ['get', 'mag'],
                            0,
                            0,
                            6,
                            0.5
                        ],
                        // Increase the heatmap color weight weight by zoom level
                        // heatmap-intensity is a multiplier on top of heatmap-weight
                        'heatmap-intensity': [
                            'interpolate',
                            ['linear'],
                            ['zoom'],
                            0,
                            1,
                            9,
                            2,
                            10,
                            2
                        ],
                        // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
                        // Begin color ramp at 0-stop with a 0-transparancy color
                        // to create a blur-like effect.
                        'heatmap-color': [
                            'interpolate',
                            ['linear'],
                            ['heatmap-density'],
                            0,
                            'rgba(33,102,172,0)',
                            0.2,
                            'rgb(103,169,207)',
                            0.4,
                            'rgb(209,229,240)',
                            0.6,
                            'rgb(253,219,199)',
                            0.8,
                            'rgb(239,138,98)',
                            1,
                            'rgb(178,24,43)'
                        ],
                        // Adjust the heatmap radius by zoom level
                        'heatmap-radius': [
                            'interpolate',
                            ['linear'],
                            ['zoom'],
                            0,
                            1,
                            9,
                            3,
                            23,
                            5
                        ],
                        // Transition from heatmap to circle layer by zoom level
                        'heatmap-opacity': [
                            'interpolate',
                            ['linear'],
                            ['zoom'],
                            0,
                            1,
                            23,
                            1
                        ]
                    }
                },
                'waterway-label'
            );

            this.mySmartMap.addLayer(
                {
                    'id': 'earthquakes-point',
                    'type': 'circle',
                    'source': 'earthquakes',
                    'minzoom': 18,
                    'paint': {
                        // Size circle radius by earthquake magnitude and zoom level
                        'circle-radius': [
                            'interpolate',
                            ['linear'],
                            ['zoom'],
                            7,
                            ['interpolate', ['linear'], ['get', 'mag'], 1, 0.1, 6, 0.2]
                        ],
                        // Color circle by earthquake magnitude
                        'circle-color': [
                            'interpolate',
                            ['linear'],
                            ['get', 'mag'],
                            0.2,
                            'rgba(33,102,172,0)'
                        ],
                        'circle-stroke-color': 'rgb(103,169,207)',
                        'circle-stroke-width': 0.1,
                        // Transition from heatmap to circle layer by zoom level
                        'circle-opacity': 0.1
                    }
                },
                'waterway-label'
            );
        },
    },
    mounted() {
        let self = this;
        this.mySmartMap.on('load', () => {
            self.applyHeatMap();
            // Hide labels
            this.mySmartMap.setLayoutProperty('road-label-small', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('road-label-medium', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('road-label-large', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('building-number-label', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('building-number', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('place-label', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('poi-label', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('poi-scalerank2', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('natural-label', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('water-label', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('country-label', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('state-label', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('settlement-label', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('settlement-subdivision-label', 'visibility', 'none');
            this.mySmartMap.setLayoutProperty('neighborhood-label', 'visibility', 'none');

        })
    },
};
</script>

<style></style>